import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const ExportPanel = ({ onExport }) => {
  const [exportOptions, setExportOptions] = useState({
    format: 'pdf',
    includeCharts: true,
    includeRawData: false,
    includeComparison: true,
    emailCopy: false
  });

  const [isExporting, setIsExporting] = useState(false);

  const formatOptions = [
    { value: 'pdf', label: 'PDF', icon: 'FileText' },
    { value: 'excel', label: 'Excel', icon: 'FileSpreadsheet' },
    { value: 'powerpoint', label: 'PowerPoint', icon: 'Presentation' },
    { value: 'csv', label: 'CSV', icon: 'Table' }
  ];

  const handleExport = async () => {
    setIsExporting(true);
    try {
      await onExport(exportOptions);
      setTimeout(() => {
        setIsExporting(false);
      }, 2000);
    } catch (error) {
      console.error('Export failed:', error);
      setIsExporting(false);
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 shadow-warm">
      <h3 className="text-lg font-heading font-semibold text-foreground flex items-center gap-2 mb-4">
        <Icon name="Download" size={20} />
        تصدير التقرير
      </h3>
      <div className="space-y-4">
        <div>
          <label className="text-sm font-medium text-foreground mb-2 block">
            تنسيق التصدير
          </label>
          <div className="grid grid-cols-2 gap-2">
            {formatOptions?.map((format) => (
              <button
                key={format?.value}
                onClick={() => setExportOptions(prev => ({ ...prev, format: format?.value }))}
                className={`p-3 rounded-lg border transition-all duration-250 flex items-center gap-2 ${
                  exportOptions?.format === format?.value
                    ? 'border-primary bg-primary/10' :'border-border hover:bg-muted'
                }`}
              >
                <Icon name={format?.icon} size={18} />
                <span className="text-sm font-medium">{format?.label}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="space-y-3 pt-2">
          <Checkbox
            label="تضمين الرسوم البيانية"
            checked={exportOptions?.includeCharts}
            onChange={(e) => setExportOptions(prev => ({ ...prev, includeCharts: e?.target?.checked }))}
          />
          <Checkbox
            label="تضمين البيانات الخام"
            checked={exportOptions?.includeRawData}
            onChange={(e) => setExportOptions(prev => ({ ...prev, includeRawData: e?.target?.checked }))}
          />
          <Checkbox
            label="تضمين المقارنات"
            checked={exportOptions?.includeComparison}
            onChange={(e) => setExportOptions(prev => ({ ...prev, includeComparison: e?.target?.checked }))}
          />
          <Checkbox
            label="إرسال نسخة بالبريد الإلكتروني"
            checked={exportOptions?.emailCopy}
            onChange={(e) => setExportOptions(prev => ({ ...prev, emailCopy: e?.target?.checked }))}
          />
        </div>

        <Button
          variant="default"
          fullWidth
          onClick={handleExport}
          loading={isExporting}
          iconName="Download"
          iconPosition="right"
        >
          {isExporting ? 'جاري التصدير...' : 'تصدير التقرير'}
        </Button>

        <div className="pt-2 border-t border-border">
          <p className="text-xs text-muted-foreground text-center">
            سيتم تنسيق التقرير بشكل صحيح للطباعة واللغة العربية
          </p>
        </div>
      </div>
    </div>
  );
};

export default ExportPanel;